function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Chip as MUIChip, makeStyles } from '@material-ui/core';
const useStyles = makeStyles(theme => ({
  chip: {
    margin: theme.spacing(0, 1, 1, 0),
    textTransform: 'uppercase'
  }
}));

const Chip = props => {
  const classes = useStyles();
  const {
    className,
    ...otherProps
  } = props;
  return React.createElement(MUIChip, _extends({}, otherProps, {
    className: `${classes.chip} ${className || ''}`
  }));
};

Chip.propTypes = {
  label: PropTypes.node.isRequired
};
export default Chip;